import React, { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom';
import parse from 'html-react-parser';

//import Footer from '../../util/Footer';
import HeaderInicio from '../../util/headerInicio';
import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline'
// import CheckCircleOutlin2 from '@material-ui/icons/AirlineSeatLegroomNormalRounded'

//Logos
/* import { IconButton } from '@fluentui/react/lib/Button'; */
import { initializeIcons } from 'office-ui-fabric-react';
// import correctoLogo from '../../../assets/svg/2.png'
// import logoAcreUDD from '../../../assets/images/background.jpg';
// import CarrerasPostuladas from './CarrerasPostuladas';
// import { animateScroll as scroll } from 'react-scroll';
import IViewInstrucciones from '../../view-interfaces/IViewInstrucciones';
//import { getToken, ObtieneEtapasLogic, ObtieneInstruccionesLogic, useStylesList, ObtieneSiguienteEtapaLogic } from '../../view-model/Inicio/PostulacionesEstudiante.logic';
import { ObtieneEtapasLogic, ObtieneInstruccionesLogic, useStylesList} from '../../view-model/Inicio/PostulacionesEstudiante.logic';
import { InsertPrimeraEtapaProcesoLogic } from '../../view-model/EtapasProceso/EtapasProceso.logic';
import IViewEtapas from '../../view-interfaces/IViewEtapas';
import { ObtieneTieneFirmaContratoLogic } from '../../view-model/Contrato/Contrato.logic';
import { Button, CircularProgress, List, ListItem, ListItemText } from '@material-ui/core';
initializeIcons();
type Props = {
    rut: number;
    codCarrera: string;
    codigoNegocio: number;
    codigoPlanificacionAcademica: number;
    codsede: string;
    nombreCarrera: string;
    nombreAlumno: string;
    numeroAlumno: string;
}
// const iconEtapas: IIconProps  = {iconName:'F293'}
// const iconEtapas2: IIconProps  = {iconName:'BranchCommit'}
const Instrucciones: React.FC<Props> = (
    { rut, codCarrera, codigoNegocio, codigoPlanificacionAcademica, codsede, nombreCarrera, nombreAlumno, numeroAlumno }) => {
    const history = useHistory();
    const location = useLocation();

    const [instrucciones, setInstrucciones] = useState('');
    const lista: Array<IViewEtapas> = []; //IViewPostulaciones
    const [listaEtapas, setListaEtapas] = useState(lista);
    //const [checked, setChecked] = React.useState([1]);
    const [rutParametro, setRutParametro] = useState(0);
    const [anioPromocionParametro, setAnioPromocionParametro] = useState(0);
    const [periodoPromocionParametro, setPeriodoPromocionParametro] = useState(0);
    //const [codCarreraParametro, setCodCarreraParametro] = useState('');
    //const [codigoNegocioParametro, setCodigoNegocioParametro] = useState(0);
    //const [numeroAlumnoParametro, setNumeroAlumnoParametro] = useState('');
    const [loading, setLoading] = useState(false);
    const [menuSeleccionado, setMenuSeleccionado] = useState('');
    const [debeFirmarContrato, setDebeFirmarContrato] = useState(false);

    const handleCargaDatosIniciales = () => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        if (_params.rut !== null) { rut = Number(_params.rut) }

        console.log("INSTRUCCION");
        console.log(_params);

        nombreAlumno = _params.nombreAlumno;
        codigoNegocio = _params.codigoNegocio;
        codCarrera = _params.codCarrera;
        nombreCarrera = _params.nombreCarrera;
        codsede = _params.codsede;
        codigoPlanificacionAcademica = _params.codigoPlanificacionAcademica;

        setRutParametro(Number(_params.rut));
        setAnioPromocionParametro(Number(_params.anioPromocion));
        setPeriodoPromocionParametro(Number(_params.periodoPromocion));
        //setCodCarreraParametro(codCarrera);
        //setCodigoNegocioParametro(CodigoNegocio);
        //setNumeroAlumnoParametro(numeroAlumno);
        handleInstruccionesCarrera(_params.rut, _params.anioPromocion, _params.periodoPromocion);
    }

    const selListaInstrucciones = (error: Boolean, err: string, Instrucciones: IViewInstrucciones[]) => {
        if (error === false && Instrucciones !== undefined) {
            setInstrucciones(Instrucciones[0].instrucciones.trim());
        }
    }

    const selListaEtapas = (error: Boolean, err: string, Etapas: IViewEtapas[], debeFirmar: boolean) => {
        if (error === false && Etapas !== undefined) {
            let lstEtapaRemove;
            setDebeFirmarContrato(debeFirmar);
            if (!debeFirmar)
            {
                lstEtapaRemove = Etapas.filter((tp) => tp.idEtapa !== 5 && tp.idEtapa !== 6);
            }
            else
            {
                lstEtapaRemove = Etapas;
            }
            setListaEtapas(lstEtapaRemove);
        }
    }

    const selPrimeraEtapa = (error: Boolean, err: string, data: any) => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        if (error === false && data !== undefined) {
            let count = 0;
            listaEtapas.map((e: any) => {
                if (!e.estado) {
                    count = count + 1;
                    if (count === 1) {
                        history.push({
                            pathname: "/matricula",
                            state: {
                                'rut': rutParametro,
                                'codigoNegocio': _params.codigoNegocio,
                                'codCarrera': _params.codCarrera,
                                'codigoPlanificacionAcademica': codigoPlanificacionAcademica,
                                'codsede': _params.codsede,
                                'nombreAlumno': nombreAlumno === "" || nombreAlumno === undefined ? _params.nombreAlumno : nombreAlumno,
                                'nombreCarrera': nombreCarrera === "" || nombreCarrera === undefined ? _params.nombreCarrera : nombreCarrera,
                                'numeroAlumno': numeroAlumno,
                                'anioPromocion': anioPromocionParametro,
                                'periodoPromocion': periodoPromocionParametro,
                                'idProceso': parseInt(data),
                                'debeFirmar': debeFirmarContrato,
                                'menu': e.idEtapa.toString() === "4" ? "3" : e.idEtapa.toString(),
                                'idPeriodo': _params.idPeriodo,
                                'idPersona': _params.idPersona,
                                'headers':_params.headers
                            }
                        })
                    }
                }
            })
        }
    }

    const selPrimeraEtapaManual = (error: Boolean, err: string, data: any) => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        if (error === false && data !== undefined) {
            history.push({
                pathname: "/matricula",
                state: {
                    'rut': rutParametro,
                    'codigoNegocio': _params.codigoNegocio,
                    'codCarrera': _params.codCarrera,
                    'codigoPlanificacionAcademica': codigoPlanificacionAcademica,
                    'codsede': _params.codsede,
                    'nombreAlumno': nombreAlumno === "" || nombreAlumno === undefined ? _params.nombreAlumno : nombreAlumno,
                    'nombreCarrera': nombreCarrera === "" || nombreCarrera === undefined ? _params.nombreCarrera : nombreCarrera,
                    'numeroAlumno': numeroAlumno,
                    'anioPromocion': anioPromocionParametro,
                    'periodoPromocion': periodoPromocionParametro,
                    'idProceso': parseInt(data),
                    'debeFirmar': debeFirmarContrato,
                    'menu': menuSeleccionado === "4" ? "3" : menuSeleccionado,
                    'headers':_params.headers
                }
            })
       }
    }

    const selListaFirma = (error: Boolean, err: string, data: any) => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);

        ObtieneEtapasLogic(selListaEtapas, _params.codigoNegocio, _params.codCarrera, _params.codigoPlanificacionAcademica, _params.rut, _params.anioPromocion, _params.periodoPromocion, data);
    }

    const handleInstruccionesCarrera = (rut_: number, anio_: number, periodo_: number) => {

        setLoading(true);
        ObtieneInstruccionesLogic(selListaInstrucciones, codigoNegocio, codCarrera);

        ObtieneTieneFirmaContratoLogic(selListaFirma, codigoNegocio, rut_, codCarrera, anio_, periodo_, codigoPlanificacionAcademica);
        setLoading(false);
    }

    const InsertPrimeraEtapaProceso = () => {//rutParametro

        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);

        InsertPrimeraEtapaProcesoLogic(selPrimeraEtapa, _params.rut, _params.anioPromocion, _params.periodoPromocion, _params.codigoNegocio, _params.codCarrera, _params.codigoPlanificacionAcademica, 0);
    }

    useEffect(() => {
        if (menuSeleccionado !== "")//rutParametro
        {
            let _tt = JSON.stringify(location.state);
            let _params = JSON.parse(_tt);

            InsertPrimeraEtapaProcesoLogic(selPrimeraEtapaManual, _params.rut, _params.anioPromocion, _params.periodoPromocion, _params.codigoNegocio, _params.codCarrera, _params.codigoPlanificacionAcademica, 0);
        }
    }, [menuSeleccionado])

    useEffect(() => {
        if (location.state === null || location.state === undefined) {
            history.push({
                pathname: "/Inicio"
            });

        } else {
            handleCargaDatosIniciales();
        }
    }, [])


    const classes = useStylesList();

    return (
        <>
            <HeaderInicio mostrarCallCenter={true}/>
            <main className="welcome site-main">
                <div className="site-main__container">
                    <div className="enrollment__title">Instrucciones Generales</div>
                    <div className="container">
                        <div className="row">
                            <div className="col">
                                {parse(instrucciones)}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <br></br>
                                <p className="enrollment__title">Etapas</p>
                                <div>
                                    <p style={{ color: 'gray', fontSize: 12 }} className="enrollment__back">El proceso de Matrícula Web considera 5 etapas detalladas a continuación. Podrás visualizar con (<CheckCircleOutline style={{ color: '#0062a1' }} />) cuando completes cada una de ellas.</p>
                                    <p style={{ color: 'gray', fontSize: 12 }} className="enrollment__back">Cuando completes todas las etapas, estarás matriculado.</p>
                                    <br/>
                                </div>
                                <div>
                                    <List dense className={classes.root}>
                                        {listaEtapas.map((value) => {
                                            const labelId = 'checkbox-list-secondary-label-${value}';
                                            return (
                                                <ListItem key={value.idEtapa} button onClick={() => {
                                                    if (value.estado ) {
                                                        setMenuSeleccionado(value.idEtapa.toString())
                                                    }
                                                }}>
                                                    <ListItem>
                                                        {/* value.estado ? <div><IconButton height={100} width={100} iconProps={iconEtapas2}></IconButton></div> : <IconButton height={100} width={100} style={{color:'gray'}} iconProps={iconEtapas2}></IconButton> */}
                                                        {value.estado ? <CheckCircleOutline style={{ color: '#0062a1', marginRight: 10 }} /> : <span style={{ marginRight: 35 }}></span>}
                                                        <ListItemText style={value.estado ? { color: '#0062a1' } : { color: 'black' }} id={labelId} primary={value.nombre} />
                                                    </ListItem>
                                                </ListItem>
                                            );

                                        })}
                                    </List>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <br/>
                                <Button
                                    variant="contained"
                                    //onClick={() => ReactDOM.render(<CarrerasPostuladas rut={rut} />, document.getElementById('root'))}>
                                    onClick={() => {
                                        history.push({
                                            pathname: "/carreras",
                                            state: {
                                                rut: rutParametro
                                            }
                                        })
                                        sessionStorage.removeItem('fase');
                                    }}>
                                    Volver
                                </Button>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <Button
                                    variant="contained"
                                    color="primary"
                                    //onClick={() => ReactDOM.render(<Menu />, document.getElementById('root'))}>
                                    onClick={() => {
                                        InsertPrimeraEtapaProceso()
                                    }}>
                                    Continuar
                                </Button>
                            </div>
                        </div>
                        <div className="row">
                            {loading && (<CircularProgress size={40} className={classes.buttonProgress} />)}
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
}

export default Instrucciones;